module.exports = __webpack_public_path__ + "img/sw08.69525b44.jpg";